export const questionHighlighting = [
  { boxShadow: '0 0 0 1px rgba(29,138,254,1)' },
  { width: '64px', height: '64px' },
]

export const questionHighlightingParams = {
  duration: 1000,
  iterations: 1,
}
